module.exports = __webpack_public_path__ + "static/media/feature_security_high_protection.f3b5ea9e.png";